import axios from 'axios';
import DataSvc from './data';

class Session {
  static resume() {
    const user = this.getUser();
    let promise;

    if (user) {
      axios.defaults.headers.common.Authorization = `Bearer ${user.auth_token}`;
      promise = DataSvc.tokenAuth()
        .then(this.getSupportingUserData)
        .then(data => [user].concat(data));
    } else {
      promise = Promise.reject(new Error('Invalid session. Please sign in again.'));
    }

    promise.catch(Session.end);

    return promise;
  }

  static begin(user) {
    const u = JSON.stringify(user);
    localStorage.setItem('user', u);
    return this.getSupportingUserData();
  }

  static update = this.begin;

  static end() {
    delete axios.defaults.headers.common.Authorization;
    localStorage.removeItem('user');
    localStorage.removeItem('hiddenEvents');
  }

  static getUser() {
    const user = localStorage.getItem('user');
    return JSON.parse(user);
  }

  static getSupportingUserData() {
    return Promise.all([
      DataSvc.getActiveRegistrationSession(),
      DataSvc.getClosedRegistrationSessions(),
    ]);
  }
}

export default Session;
